<template>
  <div>
    <CRow>
      <CCol><h3>Add Org</h3></CCol>
      <CCol>
        <router-link to="/orgs">
          <CButton color="primary" class="float-right">
            Back to org list
          </CButton>
        </router-link>
      </CCol>
    </CRow>
    <CCard>
      <CCardBody>
        <CCardTitle>Org Details</CCardTitle>
        <CRow>
          <CCol sm="8">
            <CInput
              label="Name"
              v-model="org.organizationName"
              placeholder="Enter Organization Name"
              :isValid="true"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8">
            <CInput
              label="Organization ID"
              v-model="org.organizationId"
              placeholder="Enter Organization ID"
              :isValid="isorganizationIdValid()"
            />
            <span>Org id should be all lowercase and no spaces</span>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8"> </CCol>
        </CRow>

        <h5 class="mt-3">Account Type</h5>
        <CRow align="center">
          <CCol sm="3" class="my-3">
            <CInputCheckbox
              label="Trial Access for Org Users"
              :checked.sync="org.appMetadata.trialUser"
            ></CInputCheckbox>
          </CCol>
        </CRow>
        <CRow align="center">
          <CCol sm="5">
            <datetime
              id="startDate"
              type="date"
              v-model="org.subscriptionStart"
            >
              <label for="startDate" slot="before">Subscription Start </label>
              <span class="description" slot="after"
                ><br /><small
                  ><i>Start date for the subscription</i></small
                ></span
              >
            </datetime>
          </CCol>

          <CCol sm="5">
            <datetime id="endDate" type="date" v-model="org.subscriptionEnd">
              <label for="startDate" slot="before">Subscription End </label>
              <span class="description" slot="after"
                ><br /><small><i>End date for the subscription</i></small></span
              >
            </datetime>
          </CCol>
        </CRow>
        <h5 class="mt-3">Access Roles</h5>

        <CRow
          v-for="number in numberOfRoles"
          :key="number"
          alignVertical="center"
        >
          <CCol sm="8" class="mt-3">
            <h5>Roles</h5>
            <CSelect
              :options="roles"
              :value.sync="org.accessRoleId[number - 1]"
            ></CSelect>
          </CCol>
          <CCol sm="4" v-if="numberOfRoles > 1">
            <a @click="reduceNumberOfRole(number)" v-if="number !== 1">
              <CIcon name="cilXCircle" class="pointer" />
            </a>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8">
            <a class="pointer" @click="addNumberOfRole"
              ><u>Click to add another role.</u></a
            >
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8" v-if="!loading" class="my-3">
            <CButton
              color="info"
              variant="outline"
              square
              :disabled="loading == true"
              @click="showModal = true"
            >
              Add new org
            </CButton>
          </CCol>
          <CCol sm="8" v-else class="my-3">
            <CSpinner color="success" />
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CToaster :autohide="3000" v-if="error.showError">
      <template>
        <CToast :show="true" header="Toast">
          {{ error.text }}
        </CToast>
      </template>
    </CToaster>
    <TheModal
      :color="'warning'"
      :size="'sm'"
      :title="'Add new organization'"
      :showModal="showModal"
      :text="`Are you sure you want to add org <b>${org.organizationName}</b>.`"
      @cancel="cancelAddOrg($event)"
      @okay="addOrg($event)"
    />
    <pre>{{ trialExpiryText }}</pre>
    <pre>{{ org }}</pre>
  </div>
</template>

<script>
import getNested from "lodash-es/get";
import { mapActions, mapState } from "vuex";
import moment from "moment";
import TheModal from "./../containers/TheModal";
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
export default {
  name: "AddOrg",
  data() {
    return {
      orgs: [],
      role: [null],
      trialExpiryText: "",
      org: {
        accessRoleId: [null],
        organizationName: "",
        organizationId: "",
        subscriptionStart: moment().toISOString(),
        subscriptionEnd: moment()
          .add(14, "days")
          .toISOString(),
        appMetadata: {
          organization: "",
          trialUser: false,
          trialExpiry: moment()
            .add(14, "days")
            .toISOString(),
        },
      },
      showPassword: false,
      error: {
        showError: false,
        text: "",
      },
      numberOfRoles: 1,
      loading: false,
      showModal: false,
    };
  },
  components: {
    TheModal,
    Datetime,
  },
  async mounted() {
    await this.getRoles();
  },
  computed: {
    ...mapState(["roles"]),
    orgNames() {
      return this.orgs.map((item) => item.organizationId);
    },
  },
  methods: {
    ...mapActions("users", ["createOrg"]),

    ...mapActions([
      "getRolesAsList",
      "getRoles",
      "createUser",
      "addRoleToUser",
      "",
    ]),

    async addOrg() {
      this.showModal = false;
      if (this.isorganizationIdValid() && this.isAccessRoleIdValid) {
        this.org.appMetadata.organization = this.org.organizationId;
        this.org.appMetadata.trialExpiry = this.org.subscriptionEnd;
        this.loading = true;
        let response = await this.createOrg(this.org);
        if (response.error) {
          this.error.showError = true;
          this.error.text = response.error_details.message;
          setTimeout(
            function(that) {
              that.error.showError = false;
              that.error.text = "";
            },
            3000,
            this
          );
        } else {
          this.org = {
            name: "",
            appMetadata: {
              organization: "",
              trialUser: false,
              trialExpiry: moment()
                .add(14, "days")
                .toISOString(),
            },
          };
          this.error.showError = true;
          this.error.text = "User Created";
          this.$router.push("/orgs");
        }
        this.loading = false;
      } else {
        this.error.showError = true;
        this.error.text = "Please correctly fill all fields";
        setTimeout(
          function(that) {
            that.error.showError = false;
            that.error.text = "";
          },
          3000,
          this
        );
      }
    },

    deleteAlert(el) {
      this.deleteModal = !this.deleteModal;
      if (this.deleteModal)
        (this.userToDelete = el.item), (this.userToDelete["index"] = el.index);
      else this.userToDelete = {};
    },

    isorganizationIdValid() {
      if (this.org.organizationId.length) {
        if (/^[a-z0-9]+$/.test(this.org.organizationId)) return true;
        return false;
      }
    },
    isAccessRoleIdValid() {
      if (this.org.accessRoleId.length) {
        return true;
        return false;
      }
    },
    callFunction() {
      console.log("calling");
    },
    addNumberOfRole() {
      if (this.numberOfRoles < this.roles.length - 1) {
        this.numberOfRoles++;
        this.org.accessRoleId.push(null);
      }
    },
    reduceNumberOfRole(index) {
      if (this.numberOfRoles > 1) {
        this.org.accessRoleId.splice(index - 1, 1);
        this.numberOfRoles = this.numberOfRoles - 1;
      }
    },
    cancelAddOrg() {
      this.showModal = false;
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>
